export class Books {
    constructor(containerId) { this.containerId = containerId; }
    init() {
        const el = document.getElementById(this.containerId);
        if(el) {
            el.innerHTML = `
                <div style="padding: 2rem; max-width: 800px; margin: 0 auto; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
                    <h1 style="margin-bottom: 1.5rem; color: #1a1a1a; text-align: center;">Books</h1>
                    <div style="background: white; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); padding: 3rem; text-align: center;">
                        <p style="color: #666; font-size: 1.1rem;">Books content coming soon.</p>
                    </div>
                </div>
            `;
        }
    }
}